<template>
  <div class="d-flex fd-column h-100">
    <app-header :header-options="headerOptions" class="flex-0-0 x-print-hide"/>
    <transition name="fade" mode="out-in">
      <router-view class="x-main-route"/>
    </transition>
  </div>
</template>

<script>
import AppHeader from '@/layouts/components/AppHeader';

export default {
  name: 'dashboard-layout',
  components: {
    AppHeader,
  },
  props: {
    headerOptions: {
      type: Object,
      default: null,
    },
  },
};
</script>
